// extracted by mini-css-extract-plugin
export default {"element":"reordableList_element__iT6D+"};